import React from 'react';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

const SddTile = ({ title, price, tileText }: { title: string; price: string; tileText: string }) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);

  return (
    <div className="sdd-tile">
      <div className="sdd-tile-first">
        <div className="sdd-tile-row">
          <p className="black-text">{title}</p>
        </div>
        {isMobile && (
          <div className={`sdd-tile-row text-right `}>
            <p className="text-right">{price}</p>
          </div>
        )}
      </div>
      <div className="sdd-tile-first">
        <div className="sdd-tile-row">
          <p>{tileText}</p>
        </div>
      </div>
      {!isMobile && (
        <div className={`sdd-tile-first`}>
          <div className={`sdd-tile-row text-right`}>
            <p className="text-right">{price}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SddTile;
